/**
 * Created by fers on 19/03/2017.
 */

import React from 'react';
import PropTypes from 'prop-types';
import ChannelIcon from '../../channel-defs/ChannelIcon.react';
import {injectIntl, IntlShape} from 'react-intl';

import {getMessageArgsForDataSource} from '../screen-settings/DataSourceList.react';

class DataSourceDecorationAdd extends React.Component {
    static propTypes = {
        children: PropTypes.any,
        dataSource: PropTypes.object,
        dataSourceToAdd: PropTypes.object,
        goBack: PropTypes.func,
        intl: PropTypes.object,
    };

    render() {
        let dataSourceToAdd = this.props.dataSourceToAdd;

        let title = "";
        let description = "";

        let messageArgs = getMessageArgsForDataSource(dataSourceToAdd, this.props.dataSource);

        if (dataSourceToAdd.description) {
            description += dataSourceToAdd.description;
        } else {
            description += this.props.intl.formatMessage({
                id: 'dataSource.' + dataSourceToAdd.typeId + '.description',
            }, messageArgs);
        }

        if (dataSourceToAdd.name) {
            title += dataSourceToAdd.name;
        } else {
            title += this.props.intl.formatMessage({
                id: 'dataSource.' + dataSourceToAdd.typeId + '.name',
            }, messageArgs);
        }

        return (
            <div className="">
                <div className="dataSource-item-detail">
                    <div className="dataSource-head flex">
                        <div className={"dataSource-item-close"}>
                            <div className="btn btn-inline" onClick={this.props.goBack}><span className="fa fa-chevron-left"/></div>
                        </div>
                        <div className="dataSource-title-icon">
                            {dataSourceToAdd.channelDef && dataSourceToAdd.channelDef.icon ? <ChannelIcon channelDef={dataSourceToAdd.channelDef} size={32} /> : <ChannelIcon channelDef={dataSourceToAdd} size={32} />}
                        </div>
                        <div className={"dataSource-item-title" + (description ? '' : ' one-line-title')}>
                            <h3>{title}</h3>

                            {description ? <small>{description}</small> : null}
                        </div>
                    </div>

                    <div className="dataSource-item-dataSources">
                        {this.props.children}
                    </div>
                </div>
            </div>
        );
    }
}

export default injectIntl(DataSourceDecorationAdd);
